module.exports = __webpack_public_path__ + "img/neo-logo.ec3e901f.png";